export const translations = {
  pt: {
    pagination: {
      navigation: "Paginação",
      previous: "Página anterior",
      next: "Próxima página",
      page: "Página",
      of: "de",
    },
    identity: {
      lightMode: "Ativar modo claro",
      darkMode: "Ativar modo escuro",
      skip: "Pular abertura",
      skipContent: "Ir para o conteúdo",
      intro: "Código que conecta ideias.",
      signature: "FULL STACK · MOBILE · CLOUD",
      based: "BRASIL / PARA O MUNDO",
      statement: "Entre a precisão da engenharia e a sensibilidade do design. Construo experiências digitais do primeiro esboço ao último deploy.",
      explore: "Explorar projetos",
      craft: "Lógica no traço. Intenção em cada detalhe.",
      bridge: "ENGENHARIA + DESIGN + CÓDIGO",
      scroll: "Conheça meu trabalho",
      openMenu: "Abrir menu",
      closeMenu: "Fechar menu",
      language: "Selecionar idioma",
      backTop: "Voltar ao topo"
    },
    nav: {
      about: "Sobre",
      experience: "Experiência",
      projects: "Projetos",
      techstack: "Tech Stack",
      certifications: "Certificações",
      contact: "Contato",
    },
    hero: {
      greeting: "Olá, sou",
      role: "Software Engineer",
      tagline: "Criando sistemas elegantes, acessíveis e de alta performance",
      availability: "Disponível",
      scroll: "Scroll",
      downloadCV: "Baixar CV",
    },
    about: {
      sectionNum: "01.",
      title: "Sobre Mim",
      whoAmI: "Quem sou eu",
      bioRole: "Engenheira de Software",
      bioIntro:
        "Engenheira de Software com experiência em desenvolvimento full stack, mobile e cloud, da concepção de interfaces e APIs à implantação e manutenção de aplicações em produção. Combino uma formação em Engenharia Elétrica com uma visão integrada de produto, arquitetura e infraestrutura para transformar necessidades de negócio em soluções escaláveis.",
      bioDetails:
        "Trabalho com React, TypeScript, Vue, React Native, Node.js e PHP/Laravel, além de infraestrutura AWS — EC2, ECS, Lambda, API Gateway e CloudWatch. Foco em performance, acessibilidade, componentes reutilizáveis e code review, trabalhando com Scrum / Kanban e testes automatizados com Vitest, Playwright e Cypress. Atualmente cursando pós-graduação em Engenharia de Software.",
      location: "Brasil",
      currentStudy: "Pós-graduação em Engenharia de Software",
      availabilityText: "Disponível",
      availablePill: "Disponível para trabalho",
      basedIn: "Baseada em",
      studying: "Estudando",
      techStackLabel: "Tech Stack",
      educationLabel: "Formação",
      languages: "Idiomas",
      langPt: "Português",
      langPtLevel: "Nativo",
      langEn: "Inglês",
      langEnLevel: "Intermediário/Avançado",
      langEs: "Espanhol",
      langEsLevel: "Intermediário",
      frontend: "Frontend",
      frontendDesc:
        "React, TypeScript, Vue, Next.js, Nuxt, TailwindCSS, Shadcn/UI, React Hook Form, Zustand, Zod, Framer Motion, TanStack Query",
      backend: "Backend",
      backendDesc:
        "Node.js • NestJS • Laravel • REST APIs • GraphQL • Authentication (JWT, cookies) • WebSockets • Payments (Stripe)",
      mobile: "Mobile",
      mobileDesc: "React Native • Expo • PWA • Push Notifications",
      databases: "Segurança & Observabilidade",
      databasesDesc: "Snyk, Sentry, Microsoft Clarity, New Relic, Google Analytics",
      devops: "DevOps & Cloud",
      devopsDesc:
        "Docker • AWS (EC2, ECS, Lambda, API Gateway, S3, RDS, CloudWatch) • GitHub Actions CI/CD",
      architecture: "Arquitetura",
      architectureDesc:
        "Clean Architecture • SOLID • Microservices • DDD • Scalable SaaS systems • API Design",
      ai: "Inteligência Artificial",
      aiDesc:
        "Prompt Engineering • RAG (Retrieval-Augmented Generation) • LLM APIs (OpenAI, Claude) • Embeddings & Busca Semântica",
      testing: "Testes",
      testingDesc:
        "Vitest • Playwright • Cypress • Testes Unitários • Testes de Integração • Testes E2E",
      edu1Degree: "Bacharelado em Engenharia Elétrica",
      edu1Institution: "Universidade Federal de Campina Grande",
      edu1Period: "Jan 2018 - Dez 2024",
      edu1Highlights: [
        "Ênfase em desenvolvimento de software, eletrônica, controle e automação",
        "Bolsista no LIEC - projetos de integração hardware e software",
        "Bolsista na Trybe - curso de Web Development (fullstack)",
      ],
      edu2Degree: "Formação Técnica em Análise e Desenvolvimento de Sistemas",
      edu2Institution: "SENAI",
      edu2Period: "2020 - 2022",
      edu2Highlights: [
        "Conhecimento sólido em modelagem de dados e bases relacionais",
        "Projetos integrativos com design de modelos ER e scripts de migração",
      ],
    },
    experience: {
      sectionNum: "02.",
      title: "Experiência",
      subtitle:
        "Trajetória profissional em desenvolvimento de software, desde projetos académicos até sistemas em produção.",
      current: "Atual",
      previous: "Anterior",
      jobs: [
        {
          company: "CopanestRIO",
          role: "Software Engineer",
          period: "Atual",
          description: [
            "Desenvolvimento e manutenção de landing page e sistema de gestão da cooperativa utilizando Vue, HTML, CSS e JavaScript.",
            "Desenvolvimento backend com PHP e Laravel para APIs e integrações do sistema.",
            "Containerização com Docker e deploy em ambiente AWS (EC2, S3, RDS) com pipeline de CI/CD.",
            "Gestão de dados com MySQL para o sistema da cooperativa.",
          ],
        },
        {
          company: "Auclan Design",
          role: "Mobile Developer · Freelancer",
          period: "Anterior",
          description: [
            "Desenvolvimento de um novo app Dental Uni com novo design e base white label em React Native e Expo.",
            "Desenvolvimento de interfaces mobile modernas, performáticas e acessíveis para gestão odontológica.",
            "Responsável pela publicação dos apps em produção na Apple Store e Google Play.",
          ],
        },
        {
          company: "Horus",
          role: "Software Developer",
          period: "Anterior",
          description: [
            "Desenvolvimento de interfaces modernas e responsivas com React, Vue e TypeScript para o sistema de faturamento médico.",
            "Backend com PHP e Laravel — APIs RESTful, autenticação e regras de negócio do sistema hospitalar.",
            "Containerização com Docker (multi-stage builds) e deploy em AWS EC2 com pipelines de CI/CD via GitHub Actions.",
            "Gestão de infraestrutura AWS: EC2, S3 para assets e RDS MySQL em ambiente de produção.",
          ],
        },
        {
          company: "Grupo Neiva",
          role: "Software Developer",
          period: "Anterior",
          description: [
            "Projetos com Vue, Nuxt, Laravel, PHP, MySQL, React Native.",
            "Desenvolvimento de landing pages e sistemas como Evoluir EAD, PNLD.",
            "Participação ativa em code reviews, melhorias de UX e deploy contínuo.",
          ],
        },
        {
          company: "UFCG",
          role: "Software Developer",
          period: "Anterior",
          description: [
            "Desenvolvimento de aplicações com Next.js, NestJS, Node.js, React Native e MongoDB.",
            "Automação de processos laboratoriais e melhorias de performance.",
            "Aplicação de princípios de Clean Code e Clean Architecture.",
          ],
        },
      ],
    },
    projects: {
      sectionNum: "03.",
      title: "Projetos",
      subtitle:
        "Uma seleção de projetos que demonstram as minhas competências em diferentes áreas do desenvolvimento.",
      wipLabel: "Em desenvolvimento",
      items: [
        {
          title: "DENTAL UNI",
          subtitle: "App Mobile de Gestão Odontológica",
          description:
            "Novo aplicativo Dental Uni desenvolvido para a Auclan Design, com novo design e base white label em React Native e Expo. Existe um app em produção; esta nova versão aguarda o desenvolvimento do backend para integração e a publicação.",
        },
        {
          title: "HORUS",
          subtitle: "Plataforma de Faturamento Médico",
          description:
            "Landing Page e Sistema de Faturamento Médico. Interface moderna para gestão de faturamento hospitalar.",
        },
        {
          title: "CoopanestRIO",
          subtitle: "Landing page + Portal do Cooperado",
          description:
            "Dois subprojetos: site institucional e portal com guias, indicadores e consultas financeiras.",
        },
        {
          title: "EVOLUIR",
          subtitle: "Plataforma EAD",
          description:
            "Landing page Evoluir, sistema educacional e catálogo PNLD de 2024: três projetos no mesmo case.",
        },
        {
          title: "ECONOWISE",
          subtitle: "Sistema de Automação IoT",
          description:
            "Aplicação de automação, monitoramento e controle de ar-condicionados. Projeto de TCC.",
        },
      ],
    },
    techstack: {
      sectionNum: "05.",
      title: "Tech Stack",
      subtitle:
        "Tecnologias e ferramentas que utilizo para criar experiências digitais de alta qualidade.",
      frontend: "Frontend",
      backend: "Backend",
      tools: "Ferramentas & DevOps",
      ai: "Inteligência Artificial",
      testing: "Testes",
      stats: {
        technologies: "Tecnologias",
        projects: "Projetos",
        experience: "Experiência",
        frameworks: "Frameworks",
        experienceValue: "5+ anos",
      },
    },
    certifications: {
      sectionNum: "04.",
      title: "Certificações",
      subtitle:
        "Cursos e certificações concluídos ao longo da minha trajetória profissional.",
      copyLink: "Copiar link",
      copied: "Copiado!",
      download: "Download",
      view: "Ver certificado",
      close: "Fechar",
      all: "Todos",
      typeCourse: "Curso",
      typeDiploma: "Diploma",
      statsCourses: "cursos",
      statsHours: "horas de conteúdo",
      statsInstitutions: "instituições",
    },
    contact: {
      sectionNum: "06.",
      title: "Contato",
      subtitle:
        "Interessado(a) em colaborar? Envie uma mensagem e responderei o mais breve possível.",
      defaultSubject: "Contato via portfólio",
      info: "Informações",
      email: "Email",
      phone: "Telefone",
      locationLabel: "Localização",
      githubLabel: "GitHub",
      linkedinLabel: "LinkedIn",
      nameLabel: "Nome",
      namePlaceholder: "O teu nome",
      emailLabel: "Email",
      emailPlaceholder: "email@exemplo.com",
      subjectLabel: "Assunto",
      subjectPlaceholder: "Assunto da mensagem",
      messageLabel: "Mensagem",
      messagePlaceholder: "Escreve a tua mensagem aqui...",
      send: "Enviar Mensagem",
      sending: "A enviar...",
      sent: "Enviado!",
      requiredFields: "Campos obrigatórios",
      requiredFieldsDesc: "Por favor, preencha todos os campos obrigatórios.",
      successTitle: "Mensagem enviada!",
      successDesc: "Obrigada pelo contacto. Responderei em breve!",
      errorTitle: "Erro ao enviar",
      errorDesc: "Ocorreu um problema. Tente novamente ou envie por email.",
    },
    footer: {
      navigation: "Navegação",
      connect: "Conecta",
      madeWith: "Feito com",
      by: "por",
      rights: "Todos os direitos reservados.",
    },
  },

  en: {
    pagination: {
      navigation: "Pagination",
      previous: "Previous page",
      next: "Next page",
      page: "Page",
      of: "of",
    },
    identity: {
      lightMode: "Switch to light mode",
      darkMode: "Switch to dark mode",
      skip: "Skip intro",
      skipContent: "Skip to content",
      intro: "Code that connects ideas.",
      signature: "FULL STACK · MOBILE · CLOUD",
      based: "BRAZIL / BUILT FOR EVERYWHERE",
      statement: "Where engineering precision meets thoughtful design. I build digital experiences from the first sketch to the final deployment.",
      explore: "Explore projects",
      craft: "Logic in every line. Purpose in every detail.",
      bridge: "ENGINEERING + DESIGN + CODE",
      scroll: "Discover my work",
      openMenu: "Open menu",
      closeMenu: "Close menu",
      language: "Select language",
      backTop: "Back to top"
    },
    nav: {
      about: "About",
      experience: "Experience",
      projects: "Projects",
      techstack: "Tech Stack",
      certifications: "Certifications",
      contact: "Contact",
    },
    hero: {
      greeting: "Hi, I'm",
      role: "Software Engineer",
      tagline: "Crafting elegant, accessible & high-performance systems",
      availability: "Available",
      scroll: "Scroll",
      downloadCV: "Download CV",
    },
    about: {
      sectionNum: "01.",
      title: "About Me",
      whoAmI: "Who am I",
      bioRole: "Software Engineer",
      bioIntro:
        "Software Engineer with experience across full stack, mobile, and cloud development, from designing interfaces and APIs to deploying and maintaining production applications. I combine a background in Electrical Engineering with an integrated approach to product, architecture, and infrastructure to turn business needs into scalable software.",
      bioDetails:
        "I work with React, TypeScript, Vue, React Native, Node.js and PHP/Laravel, alongside AWS infrastructure — EC2, ECS, Lambda, API Gateway and CloudWatch. Focused on performance, accessibility, reusable components and code review, working with Scrum / Kanban and automated testing using Vitest, Playwright and Cypress. Currently pursuing a postgraduate degree in Software Engineering.",
      location: "Brazil",
      currentStudy: "Postgraduate in Software Engineering",
      availabilityText: "Available",
      availablePill: "Available for work",
      basedIn: "Based in",
      studying: "Studying",
      techStackLabel: "Tech Stack",
      educationLabel: "Education",
      languages: "Languages",
      langPt: "Portuguese",
      langPtLevel: "Native",
      langEn: "English",
      langEnLevel: "Intermediate/Advanced",
      langEs: "Spanish",
      langEsLevel: "Intermediate",
      frontend: "Frontend",
      frontendDesc:
        "React, TypeScript, Vue, Next.js, Nuxt, TailwindCSS, Shadcn/UI, React Hook Form, Zustand, Zod, Framer Motion, TanStack Query",
      backend: "Backend",
      backendDesc:
        "Node.js • NestJS • Laravel • REST APIs • GraphQL • Authentication (JWT, cookies) • WebSockets • Payments (Stripe)",
      mobile: "Mobile",
      mobileDesc: "React Native • Expo • PWA • Push Notifications",
      databases: "Security & Observability",
      databasesDesc: "Snyk, Sentry, Microsoft Clarity, New Relic, Google Analytics",
      devops: "DevOps & Cloud",
      devopsDesc:
        "Docker • AWS (EC2, ECS, Lambda, API Gateway, S3, RDS, CloudWatch) • GitHub Actions CI/CD",
      architecture: "Architecture",
      architectureDesc:
        "Clean Architecture • SOLID • Microservices • DDD • Scalable SaaS systems • API Design",
      ai: "AI",
      aiDesc:
        "Prompt Engineering • RAG (Retrieval-Augmented Generation) • LLM APIs (OpenAI, Claude) • Embeddings & Semantic Search",
      testing: "Testing",
      testingDesc:
        "Vitest • Playwright • Cypress • Unit Testing • Integration Testing • E2E Testing",
      edu1Degree: "Bachelor's in Electrical Engineering",
      edu1Institution: "Federal University of Campina Grande",
      edu1Period: "Jan 2018 - Dec 2024",
      edu1Highlights: [
        "Emphasis on software development, electronics, control, and automation",
        "Scholarship at LIEC - hardware and software integration projects",
        "Scholarship at Trybe - Web Development course (fullstack)",
      ],
      edu2Degree: "Technical Degree in Systems Analysis and Development",
      edu2Institution: "SENAI",
      edu2Period: "2020 - 2022",
      edu2Highlights: [
        "Solid knowledge in data modeling and relational databases",
        "Integrative projects with ER model design and migration scripts",
      ],
    },
    experience: {
      sectionNum: "02.",
      title: "Experience",
      subtitle:
        "Professional journey in software development, from academic projects to production systems.",
      current: "Current",
      previous: "Previous",
      jobs: [
        {
          company: "CopanestRIO",
          role: "Software Engineer",
          period: "Current",
          description: [
            "Development and maintenance of landing page and cooperative management system using Vue, HTML, CSS and JavaScript.",
            "Backend development with PHP and Laravel for APIs and system integrations.",
            "Containerization with Docker and deployment on AWS (EC2, S3, RDS) with CI/CD pipeline.",
            "Data management with MySQL for the cooperative system.",
          ],
        },
        {
          company: "Auclan Design",
          role: "Mobile Developer · Freelancer",
          period: "Previous",
          description: [
            "Development of a new Dental Uni app with a new design and white-label foundation in React Native and Expo.",
            "Developed modern, performant and accessible mobile interfaces for dental management.",
            "Responsible for publishing the apps to production on the Apple Store and Google Play.",
          ],
        },
        {
          company: "Horus",
          role: "Software Developer",
          period: "Previous",
          description: [
            "Built modern, responsive interfaces with React, Vue and TypeScript for a medical billing platform.",
            "Backend with PHP and Laravel — RESTful APIs, authentication and hospital system business logic.",
            "Containerization with Docker (multi-stage builds) and deployment to AWS EC2 via GitHub Actions CI/CD pipelines.",
            "AWS infrastructure management: EC2, S3 for assets and RDS MySQL in production.",
          ],
        },
        {
          company: "Grupo Neiva",
          role: "Software Developer",
          period: "Previous",
          description: [
            "Projects with Vue, Nuxt, Laravel, PHP, MySQL, React Native.",
            "Development of landing pages and systems like Evoluir EAD, PNLD.",
            "Active participation in code reviews, UX improvements and continuous deployment.",
          ],
        },
        {
          company: "UFCG",
          role: "Software Developer",
          period: "Previous",
          description: [
            "Development of applications with Next.js, NestJS, Node.js, React Native and MongoDB.",
            "Automation of laboratory processes and performance improvements.",
            "Application of Clean Code and Clean Architecture principles.",
          ],
        },
      ],
    },
    projects: {
      sectionNum: "03.",
      title: "Projects",
      subtitle:
        "A selection of projects that demonstrate my skills across different areas of development.",
      wipLabel: "In development",
      items: [
        {
          title: "DENTAL UNI",
          subtitle: "Dental Management Mobile App",
          description:
            "New Dental Uni app developed for Auclan Design, with a new design and a white-label foundation in React Native and Expo. An app is already in production; this new version awaits backend development for integration and publication.",
        },
        {
          title: "HORUS",
          subtitle: "Medical Billing Platform",
          description:
            "Landing Page and Medical Billing System. Modern interface for hospital billing management.",
        },
        {
          title: "CoopanestRIO",
          subtitle: "Website + Member Portal",
          description:
            "Two subprojects: an institutional website and a member portal with claims, indicators and financial queries.",
        },
        {
          title: "EVOLUIR",
          subtitle: "E-Learning Platform",
          description:
            "Evoluir website, education system and 2024 PNLD catalog: three projects in one case.",
        },
        {
          title: "ECONOWISE",
          subtitle: "IoT Automation System",
          description:
            "Automation, monitoring and control application for air conditioners. Final thesis project.",
        },
      ],
    },
    techstack: {
      sectionNum: "05.",
      title: "Tech Stack",
      subtitle:
        "Technologies and tools I use to create high-quality digital experiences.",
      frontend: "Frontend",
      backend: "Backend",
      tools: "Tools & DevOps",
      ai: "AI",
      testing: "Testing",
      stats: {
        technologies: "Technologies",
        projects: "Projects",
        experience: "Experience",
        frameworks: "Frameworks",
        experienceValue: "5+ years",
      },
    },
    certifications: {
      sectionNum: "04.",
      title: "Certifications",
      subtitle:
        "Courses and certifications completed throughout my professional journey.",
      copyLink: "Copy link",
      copied: "Copied!",
      download: "Download",
      view: "View certificate",
      close: "Close",
      all: "All",
      typeCourse: "Course",
      typeDiploma: "Diploma",
      statsCourses: "courses",
      statsHours: "hours of content",
      statsInstitutions: "institutions",
    },
    contact: {
      sectionNum: "06.",
      title: "Contact",
      subtitle:
        "Interested in collaborating? Send a message and I'll reply as soon as possible.",
      defaultSubject: "Contact via portfolio",
      info: "Information",
      email: "Email",
      phone: "Phone",
      locationLabel: "Location",
      linkedinLabel: "LinkedIn",
      githubLabel: "GitHub",
      nameLabel: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "email@example.com",
      subjectLabel: "Subject",
      subjectPlaceholder: "Message subject",
      messageLabel: "Message",
      messagePlaceholder: "Write your message here...",
      send: "Send Message",
      sending: "Sending...",
      sent: "Sent!",
      requiredFields: "Required fields",
      requiredFieldsDesc: "Please fill in all required fields.",
      successTitle: "Message sent!",
      successDesc: "Thanks for reaching out. I'll respond shortly!",
      errorTitle: "Failed to send",
      errorDesc:
        "Something went wrong. Please try again or reach out via email.",
    },
    footer: {
      navigation: "Navigation",
      connect: "Connect",
      madeWith: "Made with",
      by: "by",
      rights: "All rights reserved.",
    },
  },

  es: {
    pagination: {
      navigation: "Paginación",
      previous: "Página anterior",
      next: "Página siguiente",
      page: "Página",
      of: "de",
    },
    identity: {
      lightMode: "Activar modo claro",
      darkMode: "Activar modo oscuro",
      skip: "Saltar introducción",
      skipContent: "Ir al contenido",
      intro: "Código que conecta ideas.",
      signature: "FULL STACK · MOBILE · CLOUD",
      based: "BRASIL / PARA EL MUNDO",
      statement: "Entre la precisión de la ingeniería y la sensibilidad del diseño. Creo experiencias digitales desde el primer boceto hasta el último despliegue.",
      explore: "Explorar proyectos",
      craft: "Lógica en cada trazo. Intención en cada detalle.",
      bridge: "INGENIERÍA + DISEÑO + CÓDIGO",
      scroll: "Conoce mi trabajo",
      openMenu: "Abrir menú",
      closeMenu: "Cerrar menú",
      language: "Seleccionar idioma",
      backTop: "Volver arriba"
    },
    nav: {
      about: "Sobre mí",
      experience: "Experiencia",
      projects: "Proyectos",
      techstack: "Tech Stack",
      certifications: "Certificaciones",
      contact: "Contacto",
    },
    hero: {
      greeting: "Hola, soy",
      role: "Software Engineer",
      tagline: "Creando interfaces elegantes, accesibles y de alto rendimiento",
      availability: "Disponible",
      scroll: "Scroll",
      downloadCV: "Descargar CV",
    },
    about: {
      sectionNum: "01.",
      title: "Sobre Mí",
      whoAmI: "Quién soy",
      bioRole: "Ingeniera de Software",
      bioIntro:
        "Ingeniera de Software con experiencia en desarrollo full stack, mobile y cloud, desde el diseño de interfaces y APIs hasta el despliegue y mantenimiento de aplicaciones en producción. Combino una formación en Ingeniería Eléctrica con una visión integral de producto, arquitectura e infraestructura para transformar necesidades de negocio en soluciones escalables.",
      bioDetails:
        "Trabajo con React, TypeScript, Vue, React Native, Node.js y PHP/Laravel, además de infraestructura AWS — EC2, ECS, Lambda, API Gateway y CloudWatch. Enfoque en rendimiento, accesibilidad, componentes reutilizables y code review, trabajando con Scrum / Kanban y pruebas automatizadas con Vitest, Playwright y Cypress. Actualmente cursando posgrado en Ingeniería de Software.",
      location: "Brasil",
      currentStudy: "Posgrado en Ingeniería de Software",
      availabilityText: "Disponible",
      availablePill: "Disponible para trabajar",
      basedIn: "Ubicada en",
      studying: "Estudiando",
      techStackLabel: "Tech Stack",
      educationLabel: "Formación",
      languages: "Idiomas",
      langPt: "Portugués",
      langPtLevel: "Nativo",
      langEn: "Inglés",
      langEs: "Español",
      langEnLevel: "Intermedio/Avanzado",
      langEsLevel: "Intermedio",
      frontend: "Frontend",
      frontendDesc:
        "React, TypeScript, Vue, Next.js, Nuxt, TailwindCSS, Shadcn/UI, React Hook Form, Zustand, Zod, Framer Motion, TanStack Query",
      backend: "Backend",
      backendDesc:
        "Node.js • NestJS • Laravel • REST APIs • GraphQL • Authentication (JWT, cookies) • WebSockets • Payments (Stripe)",
      mobile: "Mobile",
      mobileDesc: "React Native • Expo • PWA • Push Notifications",
      databases: "Seguridad & Observabilidad",
      databasesDesc: "Snyk, Sentry, Microsoft Clarity, New Relic, Google Analytics",
      devops: "DevOps & Cloud",
      devopsDesc:
        "Docker • AWS (EC2, ECS, Lambda, API Gateway, S3, RDS, CloudWatch) • GitHub Actions CI/CD",
      architecture: "Arquitectura",
      architectureDesc:
        "Clean Architecture • SOLID • Microservices • DDD • Scalable SaaS systems • API Design",
      ai: "Inteligencia Artificial",
      aiDesc:
        "Prompt Engineering • RAG (Retrieval-Augmented Generation) • LLM APIs (OpenAI, Claude) • Embeddings y Búsqueda Semántica",
      testing: "Pruebas",
      testingDesc:
        "Vitest • Playwright • Cypress • Pruebas Unitarias • Pruebas de Integración • Pruebas E2E",
      edu1Degree: "Licenciatura en Ingeniería Eléctrica",
      edu1Institution: "Universidad Federal de Campina Grande",
      edu1Period: "Ene 2018 - Dic 2024",
      edu1Highlights: [
        "Énfasis en desarrollo de software, electrónica, control y automatización",
        "Becaria en LIEC - proyectos de integración hardware y software",
        "Becaria en Trybe - curso de Web Development (fullstack)",
      ],
      edu2Degree: "Formación Técnica en Análisis y Desarrollo de Sistemas",
      edu2Institution: "SENAI",
      edu2Period: "2020 - 2022",
      edu2Highlights: [
        "Conocimiento sólido en modelado de datos y bases relacionales",
        "Proyectos integrativos con diseño de modelos ER y scripts de migración",
      ],
    },
    experience: {
      sectionNum: "02.",
      title: "Experiencia",
      subtitle:
        "Trayectoria profesional en desarrollo de software, desde proyectos académicos hasta sistemas en producción.",
      current: "Actual",
      previous: "Anterior",
      jobs: [
        {
          company: "CopanestRIO",
          role: "Software Engineer",
          period: "Actual",
          description: [
            "Desarrollo y mantenimiento de landing page y sistema de gestión de la cooperativa utilizando Vue, HTML, CSS y JavaScript.",
            "Desarrollo backend con PHP y Laravel para APIs e integraciones del sistema.",
            "Containerización con Docker y deploy en AWS (EC2, S3, RDS) con pipeline de CI/CD.",
            "Gestión de datos con MySQL para el sistema de la cooperativa.",
          ],
        },
        {
          company: "Auclan Design",
          role: "Mobile Developer · Freelancer",
          period: "Anterior",
          description: [
            "Desarrollo de una nueva app Dental Uni con nuevo diseño y base white label en React Native y Expo.",
            "Desarrollo de interfaces mobile modernas, performáticas y accesibles para gestión odontológica.",
            "Responsable de la publicación de las apps en producción en Apple Store y Google Play.",
          ],
        },
        {
          company: "Horus",
          role: "Software Developer",
          period: "Anterior",
          description: [
            "Desarrollo de interfaces modernas y responsivas con React, Vue y TypeScript para el sistema de facturación médica.",
            "Backend con PHP y Laravel — APIs RESTful, autenticación y lógica de negocio del sistema hospitalario.",
            "Containerización con Docker (multi-stage builds) y deploy en AWS EC2 mediante pipelines CI/CD con GitHub Actions.",
            "Gestión de infraestructura AWS: EC2, S3 para assets y RDS MySQL en producción.",
          ],
        },
        {
          company: "Grupo Neiva",
          role: "Software Developer",
          period: "Anterior",
          description: [
            "Proyectos con Vue, Nuxt, Laravel, PHP, MySQL, React Native.",
            "Desarrollo de landing pages y sistemas como Evoluir EAD, PNLD.",
            "Participación activa en code reviews, mejoras de UX y deploy continuo.",
          ],
        },
        {
          company: "UFCG",
          role: "Software Developer",
          period: "Anterior",
          description: [
            "Desarrollo de aplicaciones con Next.js, NestJS, Node.js, React Native y MongoDB.",
            "Automatización de procesos de laboratorio y mejoras de rendimiento.",
            "Aplicación de principios de Clean Code y Clean Architecture.",
          ],
        },
      ],
    },
    projects: {
      sectionNum: "03.",
      title: "Proyectos",
      subtitle:
        "Una selección de proyectos que demuestran mis competencias en diferentes áreas del desarrollo.",
      wipLabel: "En desarrollo",
      items: [
        {
          title: "DENTAL UNI",
          subtitle: "App Mobile de Gestión Odontológica",
          description:
            "Nueva app Dental Uni desarrollada para Auclan Design, con nuevo diseño y base white label en React Native y Expo. Ya existe una app en producción; esta nueva versión espera el desarrollo del backend para integración y publicación.",
        },
        {
          title: "HORUS",
          subtitle: "Plataforma de Facturación Médica",
          description:
            "Landing Page y Sistema de Facturación Médica. Interfaz moderna para gestión de facturación hospitalaria.",
        },
        {
          title: "CoopanestRIO",
          subtitle: "Sitio + Portal del Cooperado",
          description:
            "Dos subproyectos: sitio institucional y portal con guías, indicadores y consultas financieras.",
        },
        {
          title: "EVOLUIR",
          subtitle: "Plataforma E-Learning",
          description:
            "Sitio Evoluir, sistema educativo y catálogo PNLD de 2024: tres proyectos en un caso.",
        },
        {
          title: "ECONOWISE",
          subtitle: "Sistema de Automatización IoT",
          description:
            "Aplicación de automatización, monitoreo y control de aires acondicionados. Proyecto de TCC.",
        },
      ],
    },
    techstack: {
      sectionNum: "05.",
      title: "Tech Stack",
      subtitle:
        "Tecnologías y herramientas que utilizo para crear experiencias digitales de alta calidad.",
      frontend: "Frontend",
      backend: "Backend",
      tools: "Herramientas & DevOps",
      ai: "Inteligencia Artificial",
      testing: "Pruebas",
      stats: {
        technologies: "Tecnologías",
        projects: "Proyectos",
        experience: "Experiencia",
        frameworks: "Frameworks",
        experienceValue: "5+ años",
      },
    },
    certifications: {
      sectionNum: "04.",
      title: "Certificaciones",
      subtitle:
        "Cursos y certificaciones completados a lo largo de mi trayectoria profesional.",
      copyLink: "Copiar enlace",
      copied: "¡Copiado!",
      download: "Descargar",
      view: "Ver certificado",
      close: "Cerrar",
      all: "Todos",
      typeCourse: "Curso",
      typeDiploma: "Diploma",
      statsCourses: "cursos",
      statsHours: "horas de contenido",
      statsInstitutions: "instituciones",
    },
    contact: {
      sectionNum: "06.",
      title: "Contacto",
      subtitle:
        "¿Interesado(a) en colaborar? Envía un mensaje y responderé lo antes posible.",
      defaultSubject: "Contacto vía portfolio",
      info: "Información",
      email: "Email",
      phone: "Teléfono",
      locationLabel: "Ubicación",
      linkedinLabel: "LinkedIn",
      githubLabel: "GitHub",
      nameLabel: "Nombre",
      namePlaceholder: "Tu nombre",
      emailLabel: "Email",
      emailPlaceholder: "email@ejemplo.com",
      subjectLabel: "Asunto",
      subjectPlaceholder: "Asunto del mensaje",
      messageLabel: "Mensaje",
      messagePlaceholder: "Escribe tu mensaje aquí...",
      send: "Enviar Mensaje",
      sending: "Enviando...",
      sent: "¡Enviado!",
      requiredFields: "Campos obligatorios",
      requiredFieldsDesc: "Por favor, rellena todos los campos obligatorios.",
      successTitle: "¡Mensaje enviado!",
      successDesc: "¡Gracias por contactar! Responderé pronto.",
      errorTitle: "Error al enviar",
      errorDesc: "Algo salió mal. Inténtalo de nuevo o escríbeme por email.",
    },
    footer: {
      navigation: "Navegación",
      connect: "Conecta",
      madeWith: "Hecho con",
      by: "por",
      rights: "Todos los derechos reservados.",
    },
  },
};
